import { render, staticRenderFns } from "./MigrateDistributor.vue?vue&type=template&id=8930f914&"
import script from "./MigrateDistributor.vue?vue&type=script&lang=js&"
export * from "./MigrateDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports